import React, { useState } from "react";
import "./LogoutModal.css";

import { InputText } from "primereact/inputtext";
import PhoneInput from "react-phone-input-2";
import { Button } from "primereact/button";
import { NavLink, useNavigate } from "react-router-dom";

import "react-phone-input-2/lib/bootstrap.css";
import { useDispatch } from "react-redux";
import { logout } from "../../../redux/userSlice";
import { emptyAgencies } from "../../../redux/agencies.slice";
const LogoutModal = ({ toggleModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/login");
    dispatch(logout());
    dispatch(emptyAgencies());
    localStorage.removeItem("authToken");
  };
  return (
    <>
      <div style={{ top: "35%" }} className="modalAgency">
        <br />
        <br />
        <div className="logoutMessage1">
          <strong>
            <span className="logoutMessage">Are you sure?</span>
          </strong>
        </div>
        <div className="logoutMessage2">
          <span className="innerLogoutMessage">
            You want to logout from your account?
          </span>
        </div>
        <div className="logoutButtonClass">
          <Button
            label="Logout"
            severity="danger"
            onClick={handleLogout}
            style={{
              backgroundColor: "#F74A4A",
              border: "0px",
              width: "150px",
              height: "40px",
            }}
          />

          <Button
            label="Cancel"
            style={{
              border: "0px",
              marginLeft: "40px",
              width: "150px",
              height: "40px",
            }}
            onClick={() => {
              toggleModal(false);
            }}
          ></Button>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(false);
        }}
      ></div>
    </>
  );
};

export default LogoutModal;
